// This component provides following controls for style in charts
//  - Manual/Automatic label color
//  - Change cell font size for label
//  - Cell size
//  - Change header style

import React, { useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { SketchPicker } from 'react-color';
import { Popover } from '@mui/material';
import FormatBoldIcon from '@mui/icons-material/FormatBold';
import FormatItalicIcon from '@mui/icons-material/FormatItalic';
import FormatUnderlinedIcon from '@mui/icons-material/FormatUnderlined';
import { updateStyleOptions } from '../../../redux/DynamicMeasures/DynamicMeasuresActions';
import { RootState } from '../../../redux';
import './chartStyle.css';

const DynamicMeasureStyle = () => {
  const dispatch = useDispatch();

  const dynamicMeasureProps = useSelector((state: RootState) => state.dynamicMeasuresState);

  const dmProps =
    dynamicMeasureProps.dynamicMeasureProps[`${dynamicMeasureProps.selectedTabId}`]?.[
      `${dynamicMeasureProps.selectedTileId}`
    ]?.[`${dynamicMeasureProps.selectedTileId}.${dynamicMeasureProps.selectedDynamicMeasureId}`];

  const [fontAnchorEl, setFontAnchorEl] = useState<HTMLElement | null>(null);
  const [bgAnchorEl, setBgAnchorEl] = useState<HTMLElement | null>(null);

  const handleStyleUpdate = (option: string, value: any) => {
    dispatch(updateStyleOptions(option, value));
  };

  return (
    <div className="optionsInfo">
      <div className="optionDescription">
        <label style={{ width: '40%' }}>Background Color</label>
        <div
          style={{
            height: '1.25rem',
            width: '50%',
            marginLeft: '20px',
            backgroundColor: dmProps.styleOptions.backgroundColor,
            color: dmProps.styleOptions.backgroundColor,
            border: '2px solid darkgray',
            margin: 'auto',
            cursor: 'pointer',
          }}
          onClick={(e) => setBgAnchorEl(e.currentTarget)}
        ></div>
        <Popover
          open={Boolean(bgAnchorEl)}
          anchorEl={bgAnchorEl}
          onClose={() => setBgAnchorEl(null)}
          anchorOrigin={{
            vertical: 'bottom',
            horizontal: 'left',
          }}
          transformOrigin={{
            vertical: 'top',
            horizontal: 'left',
          }}
        >
          <div>
            <SketchPicker
              color={dmProps.styleOptions.backgroundColor}
              className="sketchPicker"
              width="16rem"
              onChangeComplete={(color) => handleStyleUpdate('backgroundColor', color.hex)}
              onChange={(color) => handleStyleUpdate('backgroundColor', color.hex)}
              disableAlpha
            />
          </div>
        </Popover>
      </div>

      <div className="optionDescription">
        <label style={{ width: '40%' }}>Font Color</label>
        <div
          style={{
            height: '1.25rem',
            width: '50%',
            marginLeft: '20px',
            backgroundColor: dmProps.styleOptions.fontColor,
            color: dmProps.styleOptions.fontColor,
            border: '2px solid darkgray',
            margin: 'auto',
            cursor: 'pointer',
          }}
          onClick={(e) => setFontAnchorEl(e.currentTarget)}
        ></div>
        <Popover
          open={Boolean(fontAnchorEl)}
          anchorEl={fontAnchorEl}
          onClose={() => setFontAnchorEl(null)}
          anchorOrigin={{
            vertical: 'bottom',
            horizontal: 'left',
          }}
          transformOrigin={{
            vertical: 'top',
            horizontal: 'left',
          }}
        >
          <div>
            <SketchPicker
              color={dmProps.styleOptions.fontColor}
              className="sketchPicker"
              width="16rem"
              onChangeComplete={(color) => handleStyleUpdate('fontColor', color.hex)}
              onChange={(color) => handleStyleUpdate('fontColor', color.hex)}
              disableAlpha
            />
          </div>
        </Popover>
      </div>

      <div
        className="optionDescription"
        style={{ display: 'flex', justifyContent: 'space-around', marginTop: '10px' }}
      >
        <FormatBoldIcon
          onClick={() => handleStyleUpdate('isBold', !dmProps.styleOptions.isBold)}
          sx={{
            border: '1px solid grey',
            borderRadius: '3px',
            backgroundColor: dmProps.styleOptions.isBold ? 'rgba(224,224,224,1)' : 'none',
            cursor: 'pointer',
          }}
        />
        <FormatItalicIcon
          onClick={() => handleStyleUpdate('isItalic', !dmProps.styleOptions.isItalic)}
          sx={{
            border: '1px solid grey',
            borderRadius: '3px',
            backgroundColor: dmProps.styleOptions.isItalic ? 'rgba(224,224,224,1)' : 'none',
            cursor: 'pointer',
          }}
        />
        <FormatUnderlinedIcon
          onClick={() => handleStyleUpdate('isUnderlined', !dmProps.styleOptions.isUnderlined)}
          sx={{
            border: '1px solid grey',
            borderRadius: '3px',
            backgroundColor: dmProps.styleOptions.isUnderlined ? 'rgba(224,224,224,1)' : 'none',
            cursor: 'pointer',
          }}
        />
      </div>
    </div>
  );
};

export default DynamicMeasureStyle;
